import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ProductEdit } from './components/edit/component';
import { ProductList } from './components/list/component';
import { ProductOrderList } from './components/productList/component';
import { ProductApiService } from './services/product-api-service';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  declarations: [ProductList, ProductOrderList, ProductEdit],
  providers: [ProductApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [ProductList],
})
export class ProductModule {}
